// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"ccf5b18c","455":"0980e627"}[chunkId] + ".chunk.js";
};